import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectChildrenPortfoStats: "[selectChildrenPortfoStats] Action",
	selectChildrenPortfoStatsLoad: "[selectChildrenPortfoStatsLoad] Action",
	selectChildrenPortfoStatsAsync: "[selectChildrenPortfoStatsAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const select_children_portfo_stats_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectChildrenPortfoStats:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectChildrenPortfoStatsLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectChildrenPortfoStatsLoad,
		payload: payload,
	});
	let config = {
		url: "select_request",
	};

	let data = {
		table: "accounting",
		method_type: "select_children_portfo_stats",
		data: payload?.data ? payload?.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectChildrenPortfoStats,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({
			type: actionTypes.selectChildrenPortfoStatsLoad,
			payload: false,
		});
	}
}

export function* selectChildrenPortfoStats() {
	yield takeEvery(actionTypes.selectChildrenPortfoStatsAsync, handleWorker);
}
